import {
	expressAddClass,
	expressEventListener,
	expressQuerySelector,
	expressRemoveClass,
	hasClass,
} from "../../common/html";
import { addWishlistItem, deleteWishlistItem } from "../../services/wishlist-service";
import { getCookie, writeCookie } from "../../utils/cookie";
import { createTemp } from "../../services/authentication-service";

export function createWishListButton(el: HTMLButtonElement) {
	const iconEl = expressQuerySelector<HTMLElement>(el, ".technical-icon-file", true);
	const iconUseEl = expressQuerySelector<HTMLElement>(iconEl, "use", true);
	const likedClass = "a-button--wishlist__icon--liked";
	const likedIconPath = "/svg/heart-filled-symbol.svg#heart-filled-symbol";
	const dislikedClass = "a-button--wishlist__icon--disliked";
	const dislikedIconPath = "/svg/heart-symbol.svg#heart-symbol";
	let liked = hasClass(iconEl, likedClass);
	let executingOnClick = false;

	const onClickAction = () => {
		if (liked) {
			const id = el.dataset.id;
			if (id) {
				deleteWishlistItem(id).then((_) => {
					expressRemoveClass(iconEl, likedClass);
					expressAddClass(iconEl, dislikedClass);
					iconUseEl.setAttribute("href", dislikedIconPath);
					liked = false;
					el.title = el.dataset.liketitle || "";
					executingOnClick = false;
				});
			}
		} else {
			const productCategoryCode = el.dataset.productcategorycode;
			const predefinedProductNameAndPvc = el.dataset.predefinedproductnameandpvc;
			if (productCategoryCode || predefinedProductNameAndPvc) {
				addWishlistItem(productCategoryCode, predefinedProductNameAndPvc).then((item) => {
					expressRemoveClass(iconEl, dislikedClass);
					expressAddClass(iconEl, likedClass);
					iconUseEl.setAttribute("href", likedIconPath);
					el.dataset.id = item.id;
					liked = true;
					el.title = el.dataset.disliketitle || "";
					executingOnClick = false;
				});
			}
		}
	};

	const onClick = (ev: MouseEvent) => {
		ev.preventDefault();
		if (executingOnClick) return;
		executingOnClick = true;
		const accId = getCookie("accid");
		const accType = getCookie("acctype");
		if (!accId) {
			createTemp().then((result) => {
				if (result.success) {
					if (accType !== result.accountType) writeCookie("acctype", result.accountType, 365);
					if (accId !== result.accountId) writeCookie("accid", result.accountId, 365);
					onClickAction();
				}
			});
		} else {
			onClickAction();
		}
	};

	const disposable = expressEventListener(el, "click", onClick);

	return {
		dispose: () => disposable.dispose(),
	};
}
